import React from 'react'
import {
  Container,
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
} from 'reactstrap'

class HeaderPreview extends React.Component {
  render() {
    const {
      primaryColor = '#01315f',
      secondaryColor = '#067ddb',
      backgroundColor = '#f3f3f3',
      textPrimary = '#01315f',
      textSecondary = '#6b6b6b',
      logoBase64
    } = this.props

    // Usar primaryColor y secondaryColor para crear el degradado del header
    const gradient = `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`

    const previewStyles = {
      '--primary-color': primaryColor,
      '--secondary-color': secondaryColor,
      '--background-color': backgroundColor,
      '--text-primary': textPrimary,
      '--text-secondary': textSecondary,
    }

    return (
      <div style={{ ...previewStyles, overflow: 'hidden', maxWidth: '100%', position: 'relative' }}>
        <div 
          className="box-shadow" 
          style={{ 
            background: gradient, 
            position: 'relative',
            padding: '8px 0'
          }}
        >
          <Container>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between' 
            }}>
              <div>
                {logoBase64 ? (
                  <img 
                    className="logo" 
                    src={logoBase64} 
                    alt="Logo Preview" 
                    style={{ maxHeight: '40px', maxWidth: '200px' }}
                  />
                ) : (
                  <img className="logo" src="/images/logo.png" alt="Logo" />
                )}
              </div>
              <div style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                <i className="fas fa-globe mr-1"></i> ES
              </div>
            </div>
          </Container>
        </div>
        <div style={{ 
          backgroundColor: backgroundColor, 
          padding: '30px 20px',
          textAlign: 'center'
        }}>
          <h1 style={{ 
            color: textPrimary, 
            marginBottom: '10px',
            fontWeight: 'bold'
          }}>
            Título de ejemplo
          </h1>
          <h2 style={{ 
            color: textSecondary,
            marginTop: '10px'
          }}>
            Subtítulo de ejemplo
          </h2>
        </div>
      </div>
    )
  }
}

export default HeaderPreview
